module.exports = __webpack_public_path__ + "static/media/papyrus_password_send_icon.e27cda1b.svg";